import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoanersComponent } from './loaners/loaners.component';


const routes: Routes = [{
  path: '',
  component: LoanersComponent,
  data: { title: null }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoanersRoutingModule { }
